// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function () {
  return {
    path: '/about',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('containers/About/About').About
        });
      }, 'about');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'community-standards',
          component: require('containers/About/CommunityGuidelines').CommunityGuidelines
        }, {
          path: 'team',
          component: require('containers/About/Team').Team
        }, {
          path: 'accessibility',
          component: require('containers/About/Accessibility').Accessibility
        }, {
          path: 'careers',
          component: require('containers/About/Careers').Careers
        }, {
          path: 'careers/:jobId',
          component: require('containers/About/CareerDetails').CareerDetails
        }]);
      }, 'about');
    }
  };
});